const $ = window.$;



export default class Navigation {
  constructor() {
    this.state = {
      collapse: true,
    }

    this.bindEvents();
  }


  bindEvents() {
    $('#js-hamburger').on('click', () => {
      this.onClick();
    });
  }


  onClick() {

    if(this.state.collapse) {
      this.showNav();
    } else {
      this.closeNav();
    }

    this.state.collapse = this.state.collapse ? false : true;
  }


  showNav() {
    $('#js-hamburger').addClass('is-active');
    $('.l-header__nav').css({
      display: 'block'
    });
    $('.l-header__primary__list').stop().slideDown();
  }



  closeNav() {
    $('#js-hamburger').removeClass('is-active');
    $('.l-header__nav').css({
      display: 'none'
    });
    $('.l-header__primary__list').stop().slideUp();
  }


}


/** WEBPACK FOOTER **
 ** ./htdocs_dev/js/utill/navigation.js
 **/